var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconEyeShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.625 4.575C9.47 2.76 7.78 1.715 6 1.715C5.11 1.715 4.245 1.975 3.455 2.46C2.665 2.95 1.955 3.665 1.375 4.575C0.875 5.36 0.875 6.635 1.375 7.42C2.53 9.24 4.22 10.28 6 10.28C6.89 10.28 7.755 10.02 8.545 9.535C9.335 9.045 10.045 8.33 10.625 7.42C11.125 6.64 11.125 5.36 10.625 4.575ZM6 8.02C4.88 8.02 3.98 7.115 3.98 6C3.98 4.885 4.88 3.98 6 3.98C7.12 3.98 8.02 4.885 8.02 6C8.02 7.115 7.12 8.02 6 8.02Z",
    fill: "#8D8E97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0002 4.57001C5.2152 4.57001 4.5752 5.21001 4.5752 6.00001C4.5752 6.78501 5.2152 7.42501 6.0002 7.42501C6.7852 7.42501 7.4302 6.78501 7.4302 6.00001C7.4302 5.21501 6.7852 4.57001 6.0002 4.57001Z",
    fill: "#8D8E97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconEyeShow);
export default __webpack_public_path__ + "static/media/common_icon_eye_show.a942e17dbaa7e5b3940ce11241f3e074.svg";
export { ForwardRef as ReactComponent };